<template>
  <div>
    <div class="main">
      <el-col :span="24" style="height: 330px;margin-left: 5px;margin-top: 5px;">
        <el-col :span="8" style="height:320px;border: 1px solid #efefef;">
          <div class="block">

            <el-carousel height="320px">
              <el-carousel-item v-for="(item,index) in carouselImgs" :key="item">
                <img :src="item.path" style="height: 320px;width: 100%;">
              </el-carousel-item>
            </el-carousel>
          </div>
        </el-col>
        <el-col :span="8" class="newsHeader">
          <el-col :span="24" style="height: 40px;background-color: #fafafa;">
            <div :class="{activeSelect : newsType=='1'}" @click="changeNewsType('1')" class="news">
              新闻动态
            </div>
            <div :class="{activeSelect : newsType=='2'}" @click="changeNewsType('2')" class="news">
              地方要闻
            </div>
            <div style="float: right;text-align: right;font-size: 12px;" class="news">
              <router-link :to="{name:'news'}" style="color:black">
                更多 >>
              </router-link>
            </div>
          </el-col>
          <el-col :span="24" style="height: 260px;">
            <ul class="newslist">
              <li v-for="(new1, index) in news" @click="jumpNewsDetail(new1.id)">
                <a style="height: 40px;">
                  {{new1.title}}
                </a>
                <span>{{new1.publishDate}}</span>
              </li>

            </ul>
          </el-col>
        </el-col>
        <el-col :span="7" class="newsHeader" style="height: 35px;border:1px solid #efefef;">

          <div style="width: 100%;height:35px;text-align: center;">
            <div style="width: 80px;height: 30px;border: 1px solid #efefef;float: left;border-right-width: 0px;">
              <select v-model="searchType" style="border: none;width: 100%;height: 30px;">
                <option value="transferList">转让项目</option>

              </select>
            </div>
            <div style="width: 150px;height: 30px; border: 0.0625rem solid #efefef;float: left;">
              <input type="text" v-model="searchKeyWord" placeholder="请输入关键词"
                style="width: 100%;height: 30px; border: none;" />
            </div>
            <div @click="searchKey()"
              style="width: 80px;float: left; cursor:pointer;height: 30px;color: white; background-color: #17A668;border: 1px solid #17A668; line-height: 30px;text-align: center;">
              搜索
            </div>
          </div>
          <div style="width: 100%; height: 280px;margin-top: 0px;border: 1px solid #efefef;">

            <div style="width: 100%;height:285px ;">
              <img :src="indexMap" style="width: 100%;height: 98%;" />

            </div>
            <!--  信阳地图-->
            <div style="position: relative;z-index:10;height:285px;width:100%;margin-top: -285px;"
              v-if="unitCode=='411500000000'">
              <div style="width:100%;height: 60px;margin-top: 10px;padding-top:20px;">
                <div @click="jumpOpen('xixian')"
                  style="width:60px;height: 60px;margin-left: 150px;cursor:pointer;float: left;">

                </div>
                <div @click="jumpOpen('huaibin')"
                  style="width:60px;height: 40px;margin-left:10px;cursor:pointer;float: left;">
                </div>
              </div>


              <div style="width:100%;height: 120px;">
                <div @click="jumpOpen('luoshan')"
                  style="width:55px;height: 70px;margin-left: 90px;margin-top:20px;cursor:pointer;float: left;">

                </div>
                <div @click="jumpOpen('guangshan')"
                  style="width:50px;height: 65px;margin-left: 6px;margin-top:30px;cursor:pointer;float: left;">
                </div>

                <div @click="jumpOpen('huangchuan')"
                  style="width:55px;height: 60px;margin-left: 0px;margin-top:0px;cursor:pointer;float: left;">

                </div>
                <div @click="jumpOpen('gushi')"
                  style="width:70px;height: 60px;margin-left: 10px;margin-top:0px;cursor:pointer;float: left;">

                </div>
              </div>

              <div style="width:100%;height: 60px;margin-top: -20px;">
                <div @click="jumpOpen('xinxian')"
                  style="width:60px;height: 60px;margin-left: 150px;cursor:pointer;float: left;">

                </div>
                <div @click="jumpOpen('shangcheng')"
                  style="width:60px;margin-top: -20px;height: 60px;margin-left:15px;cursor:pointer;float: left;">
                </div>
              </div>


            </div>

<!--开封地图-->
          <div style="position: relative;z-index:10;height:285px;width:100%;margin-top: -285px;"
            v-if="unitCode=='410200000000'">
<div style="width:100%;height: 60px;margin-top: 10px;padding-top:10px;">
                <div
                  style="width:60px;height: 60px;margin-left: 150px;cursor:pointer;float: left;">

                </div>
                <div @click="jumpOpen('lankao')"
                  style="width:120px;height: 60px;margin-left:10px;cursor:pointer;float: left;">
                </div>
              </div>

            </div>
          </div>


        </el-col>
      </el-col>
      <el-col :span="24" style="height: 200px;">
        <div class="fwzn" style="height: 175px;width: 98%;margin-left: 1%;   position: relative;">
          <div style="" class="kk-title">
            <div style=" text-align:center;" class="kk-title-text">挂牌项目</div>
            <div class="clear"></div>
          </div>
          <!-- <marquee direction="right"></marquee> -->
          <div class="iconlist">
            <a href="#" class="icon1">
              <div class="pic"><img src="../../assets/images/index/fx1.png" /></div>
              <p>土地经营权</p>
            </a>
            <a href="#" class="icon1">
              <div class="pic"><img src="../../assets/images/index/fx2.png" /></div>
              <p>集体资产</p>
            </a>
            <a href="#" class="icon2">
              <div class="pic"><img src="../../assets/images/index/fx3.png" /></div>
              <p>集体建设地</p>
            </a> <a href="#" class="icon3">
              <div class="pic"><img src="../../assets/images/index/fx4.png" /></div>
              <p>涉农项目</p>
            </a> <a href="#" class="icon5">
              <div class="pic"><img src="../../assets/images/index/fx5.png" /></div>
              <p>股权</p>
            </a> <a href="#" class="icon6">
              <div class="pic"><img src="../../assets/images/index/fx6.png" /></div>
              <p>宅基地</p>
            </a>

            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx7.png" /></div>
              <p>农民住房</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx8.png" /></div>
              <p>养殖水面</p>
            </a>

            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx9.png" /></div>
              <p>林地林木</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx10.png" /></div>
              <p>常用文书</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx11.png" /></div>
              <p>设施设备</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx12.png" /></div>
              <p>知识产权</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx13.png" /></div>
              <p>水利设施</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx14.png" /></div>
              <p>四荒地</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/nongchanpin.png" /></div>
              <p>农产品</p>
            </a>
            <!--结束-->
            <a href="#" class="icon1">
              <div class="pic"><img src="../../assets/images/index/fx1.png" /></div>
              <p>土地经营权</p>
            </a>
            <a href="#" class="icon1">
              <div class="pic"><img src="../../assets/images/index/fx2.png" /></div>
              <p>集体资产</p>
            </a>
            <a href="#" class="icon2">
              <div class="pic"><img src="../../assets/images/index/fx3.png" /></div>
              <p>集体建设地</p>
            </a> <a href="#" class="icon3">
              <div class="pic"><img src="../../assets/images/index/fx4.png" /></div>
              <p>涉农项目</p>
            </a> <a href="#" class="icon5">
              <div class="pic"><img src="../../assets/images/index/fx5.png" /></div>
              <p>股权</p>
            </a> <a href="#" class="icon6">
              <div class="pic"><img src="../../assets/images/index/fx6.png" /></div>
              <p>宅基地</p>
            </a>

            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx7.png" /></div>
              <p>农民住房</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx8.png" /></div>
              <p>养殖水面</p>
            </a>

            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx9.png" /></div>
              <p>林地林木</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx10.png" /></div>
              <p>常用文书</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx11.png" /></div>
              <p>设施设备</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx12.png" /></div>
              <p>知识产权</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx13.png" /></div>
              <p>水利设施</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/fx14.png" /></div>
              <p>四荒地</p>
            </a>
            <a href="#" class="icon7">
              <div class="pic"><img src="../../assets/images/index/nongchanpin.png" /></div>
              <p>农产品</p>
            </a>
          </div>

        </div>
      </el-col>



      <el-col :span="24" style="height: auto;overflow: hidden;">
        <div class="col-box">
          <div class="news-txt" style="width: 98%;float: left; margin-left: 1%;border:none;">
            <div class="news-title" style="font-size: 18px;width: 100%;height: 40px;line-height: 40px;padding-left:0px">

              <div :class="{activeSelect : activeSelect=='transferInfo'}" @click="selectedActive('transferInfo')"
                class="news">
                转让信息
              </div>
              <div :class="{activeSelect : activeSelect=='demandInfo'}" @click="selectedActive('demandInfo')"
                class="news">
                需求信息
              </div>
              <div :class="{activeSelect : activeSelect=='procureInfo'}" @click="selectedActive('procureInfo')"
                class="news">
                采购信息
              </div>
              <div :class="{activeSelect : activeSelect=='doneDealInfo'}" @click="selectedActive('doneDealInfo')"
                class="news">
                成交公告
              </div>

              <div :class="{activeSelect : activeSelect=='authentication'}" @click="selectedActive('authentication')"
                class="news">
                鉴证公示
              </div>

            </div>

            <div class="news-con" style="margin-top: 45px;">

              <div v-if="activeSelect=='transferInfo'">


                <div class="perTradeIndex" @click=jumpTransferDetail(trade.id) v-for="(trade, index) in trades">
                  <div style="width:100%;height:180px;float:left;">
                    <img v-if="trade.images!=null" :src="trade.images.split(',')[0]" style="height: 95%;width: 100%;" />
                  </div>
                  <div style="height:40px;margin-top:0px;position: absolute;">
                    <img v-if="trade.state==5" src="../../assets/trade/enrolling.png"
                      style="width:60px;height:40px;margin-top: 5px;margin-left: 5px;" />
                    <img v-if="trade.state==10" src="../../assets/trade/chengjiao.png"
                      style="width:60px;height:25px;margin-top: 5px;margin-left: 5px;" />

                  </div>
                  <div style="width:98%;height: auto;overflow:hidden;margin-left: 1%;;float: left;">
                    <div style="font-weight: 500;margin-top: 0px;height:42px;width:100%;  overflow: hidden; ">
                      {{trade.itemName}}
                    </div>
                    <div style="width: 100%;height: 30px;line-height: 30px;">项目编号：{{trade.itemNum}}</div>
                    <div style="width: 100%;height: 30px;line-height: 30px;">起始价格：
                      <span
                        style="color: red;font-weight: 500;line-height: 30px;">￥<strong>{{trade.price}}</strong></span>
                       {{getEnumByCode(trade.priceType)}}
                    </div>

                  </div>

                </div>

              </div>

              <ul class="newslist" v-if="activeSelect!='transferInfo'">

                <li v-if="activeSelect!='doneDealInfo'&&activeSelect!='authentication'" @click=jumpTransfer(item.id)
                  v-for="(item,index) in trades">
                  <a>{{item.itemName}}</a><span v-if="item.publishTime!=null">
                    {{item.publishTime.substr(0,10)}}</span>
                </li>
                <li v-if="activeSelect=='doneDealInfo'" @click=jumpTransfer(item.id) v-for="(item,index) in trades">
                  <a>{{item.name}}</a>
                  <span v-if="item.publishTime!=null">
                    {{item.publishTime.substr(0,10)}}</span>
                </li>

                <li v-if="activeSelect=='authentication'" @click=jumpTransfer(item.transferId)
                  v-for="(item,index) in trades">
                  <a>{{item.title}}</a>
                  <span v-if="item.updateTime!=null">
                    {{item.updateTime.substr(0,10)}}</span>
                </li>


              </ul>
            </div>
          </div>

          <!-- 	<div class="news-txt col-3 last" style="width: 27%;margin-left: 2%;float: left;">

        	</div> -->
          <div class="clearfix"></div>
        </div>
      </el-col>

      <el-col :span="24" style="height:auto;overflow: hidden; margin-top: -30px;">

        <!--推荐项目-->
        <div class="tjxm-only">
          <div style="" class="kk-title">
            <div style=" text-align:center;" class="kk-title-text">推荐项目</div>



            <div class="clear"></div>
          </div>
          <div id="tj-list" style="width: 100%;">

            <ul id="tjlb">
              <li class="tj-item" @click=jumpTransferDetail(item.id) v-for="(item,index) in tradesTuiJian"
                v-if="index<6">
                <img v-if="item.images!=null" :src="item.images.split(',')[0]">
                <div style="text-overflow: ellipsis;width: 177px;  white-space: nowrap; overflow: hidden;   ">
                  {{item.itemName}}
                </div>
              </li>
              
            </ul>
          </div>
        </div>

        <div class="news-txt" style="width: 49%;float: left;margin-top: 20px;">
          <div style="" class="kk-title">
            <div style=" text-align:center;" class="kk-title-text">通知公告</div>
            <router-link :to="{name:'notice'}" class="kk-title-more active" style="color:black">
              更多>>
            </router-link>

            <div class="clear"></div>
          </div>
          <div class="news-con">
            <ul class="newslist">
              <li v-for="(item,index) in notices" @click="jumpNoticeDetail(item.id)"><a
                  href="#">{{item.title}}</a><span>{{item.createTime.substring(0,10)}}</span></li>
            </ul>
          </div>
        </div>

        <div class="news-txt" style="width: 49%;float: left;margin-top: 20px;margin-left: 1%;">
          <div style="" class="kk-title">
            <div style=" text-align:center;" class="kk-title-text">交易规则</div> <router-link :to="{name:'tradeRule'}"
              class="kk-title-more active" style="color:black">
              更多>>
            </router-link>
            <div class="clear"></div>
          </div>
          <div class="news-con">
            <ul class="newslist">
              <li v-for="(item,index) in tradeRules" @click="jumptradeDetail(item.id)"><a
                  href="#">{{item.title}}</a><span>{{item.createTime.substring(0,10)}}</span></li>
            </ul>
          </div>
        </div>



        <div class="clearfix"></div>
      </el-col>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        unitCode: localStorage.getItem("unitCode"),
        indexMap: localStorage.getItem("indexMap"),
        news: [],
        pageNum: 1, // 默认显示第几页
        totalCount: 0, // 总条数，根据接口获取数据长度(注意：这里不能为空)
        pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
        pageSize: 8, // 默认每页显示的条数（可修改）
        type: "",
        typeName: "",
        trades: [],
        notices: [],
        activeSelect: "transferInfo", //选择
        newsType: "1",
        tradeRules: [],
        tradesTuiJian: [],
        carouselImgs: [],
        demandProjects: [], //需求项目
        searchType: "transferList",
        searchKeyWord: "",
        emnus:[],


      }
    },
    mounted() {
      this.getNotices();
      this.getTuiJian();
      this.selectedActive("transferInfo");
      this.getTradeRules();
      this.changeNewsType(1);
      this.getCarouselImgs();
   this.getEmnusByType(2);
     },
     methods: {
       async getEmnusByType(type){
         const action = "/web/queryEnumsByType/"+type;
         const {
           data: res
         } = await this.$http.get(action);
         this.emnus=res.data;
       },
        getEnumByCode(code){
         return this.emnus.find(d => d.code === code).desc;
       },
      searchKey() {
        if (this.searchKeyWord == "") {
          return;
        }
        this.$router.push({
          name: 'transferList',
          query: {
            itemName: this.searchKeyWord
          }
        })
      },
      jumpTransferDetail(ids) {
        this.$router.push({
          name: 'transferDetail',
          query: {
            id: ids
          }
        })
      },
      async selectedActive(type) { //选择-需求信息、转出信息、成交信息
        this.activeSelect = type;
        this.trades = [];

        var action = "";
        if (type == "demandInfo") {
          action = "/web/demandList?pageNum=1&pageSize=9&type=&unitCode=" + this.unitCode;
        }
        if (type == "procureInfo") {
          this.trades = [];
          const {
            data: res1
          } = await this.$http.get("/web/v1/transferList?typeList=11,12,13&pageNum=1&pageSize=10&unitCode=" + this
            .unitCode);
          this.trades = res1.data.content;
          return;
        }
        if (type == "transferInfo") {
          action = "/web/v1/transferList?pageNum=1&pageSize=8&type=&unitCode=" + this.unitCode;
          const {
            data: res
          } = await this.$http.get(action);
          this.trades = res.data.content;
          return;

        }

        if (type == 'doneDealInfo') {
          const {
            data: res
          } = await this.$http.get("/web/announcement?pageNum=" + this.pageNum + "&pageSize=9&unitCode=" + this
            .unitCode);
          this.trades = res.data.list;
          return;
        }
        if (type == 'authentication') {
          const {
            data: res
          } = await this.$http.get("/web/getAuthentication?pageNum=" + this.pageNum + "&pageSize=9&unitCode=" + this
            .unitCode);
          this.trades = res.data.list;
          return;
        }
        const {
          data: res
        } = await this.$http.get(action);
        this.trades = res.data.list;




      },
      async getTuiJian() {
        var action = "/web/v1/transferList?pageNum=1&pageSize=9&type=&unitCode=" + this.unitCode;
        const {
          data: res
        } = await this.$http.get(action);
        this.tradesTuiJian = res.data.content;
      },

      async changeNewsType(type) {
        this.newsType = type;
        const action = "/web/newCenterList?pageNum=1&pageSize=7&type=" + type + "&unitCode=" + this.unitCode;
        const {
          data: res
        } = await this.$http.get(action);
        this.news = res.data.list;
      },
      async getCarouselImgs() {
        const action = "/web/carousel/" + this.unitCode;
        const {
          data: res
        } = await this.$http.get(action);
        this.carouselImgs = res.data;
      },

      changeType(type) {
        this.newsType = type;
        this.type = type;
      },
      jumpTransfer(ids) {
        var path = "";
        if (this.activeSelect == "demandInfo") {
          path = "demandDetail";
        }
        if (this.activeSelect == "transferInfo") {
          path = "transferDetail";
        }
        if (this.activeSelect == "procureInfo") {
          path = "procureDetail";
        }
        if (this.activeSelect == "doneDealInfo") {
          path = "doneDealDetail";
        }
        if (this.activeSelect == "authentication") {
          path = "verifyDetail";
        }

        this.$router.push({
          name: path,
          query: {
            id: ids
          }
        })

      },
      jumpTransferDetail(ids) {
        var path = "transferDetail";

        this.$router.push({
          name: path,
          query: {
            id: ids
          }
        })

      },
      async getNotices() {
        const action = "/web/noticeAnnouncementList?unitCode=" + this.unitCode + "&pageNum=1&pageSize=7&type=1";
        const {
          data: res
        } = await this.$http.get(action);
        this.notices = res.data.list;
      },
      async getTradeRules() {
        const action = "/web/trade/list?&type=1&unitCode=" + this.unitCode + "&pageNum=1&pageSize=7&type=1";
        const {
          data: res
        } = await this.$http.get(action);
        this.tradeRules = res.data.content;
      },
      jumpNewsDetail(ids) {
        this.$router.push({
          name: "newsDetail",
          params: {
            id: ids
          }
        })

      },
      jumpDemandProject(ids) {

        let routeUrl = this.$router.resolve({
          path: "/procureDetail",
          query: {
            id: ids
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      jumpOpen(url) {
        window.open("http://" + url + ".zwdit.com", '_blank');

      },

      handleSizeChange(val) { // 每页显示的条数，选择每页条数的时候执行
        console.log("handleSizeChange")
        this.pageSize = val // 改变每页显示的条数
        this.getNews() // 点击每页显示的条数时，显示第一页
        this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
      },
      handleCurrentChange(val) {
        this.pageNum = val; // 改变默认的页数
        this.getNews() // 切换页码时，要获取每页显示的条数
      },
      handleClose(done) {
        done();
      },

    },


  };
</script>

<style lang="scss">
  .el-carousel__button {
    width: 23px;
  }
</style>

<style>
  @import url("../../assets/css/index.css");
  @import url("../../assets/css/base.css");
  @import url("../../assets/css/main.css");
  @import url("../../assets/css/news.css");

  .perTradeIndex {
    width: 23.5%;
    height: 280px;
    float: left;
    border: 1px solid #cccccc4f;
    margin-left: 1%;
    margin-top: 10px;
    cursor: pointer;


  }

  .perTradeIndex:hover {
    /* border: 1px solid #4cb05040; */

    box-shadow: 2px 3px 5px 0px rgba(0, 0, 0, 0.5);

  }

  a {
    color: black;
  }

  .iconlist {
    animation: rolling 18s linear infinite;
    position: absolute;
    display: flex;
  }



  @keyframes rolling {
    from {
      transform: translateX(0);
    }

    to {
      transform: translateX(-50%);
    }
  }

  li {
    cursor: pointer;
  }

  .news {
    float: left;
    width: 110px;
    text-align: center;
    height: 42px;
    cursor: pointer;
    line-height: 42px;
  }

  .newsHeader {
    height: 320px;
    border: 1px solid #efefef;
    margin-left: 15px;
  }

  .activeSelect {
    background-color: #4cb050;
    color: white;
  }

  .hone-container {
    height: 100%;
  }

  a-layout-content {
    height: 100%;
  }

  .ant-layout-header {
    /* 2850A0 */
    padding: 0px;
    background-color: #3c8dbc !important;
  }

  .main {
    width: 1220px;
    margin: 0 auto;
    height: auto;
    overflow: hidden;
    background-color: white;
    margin-top: 2px;
  }
</style>
